(() => {
  angular
    .module('app')
    .controller(
      'corporate.views.benefitGroups.inpatient.benefitDetail',
      BenefitDetailPageController
    );

  BenefitDetailPageController.$inject = [
    '$scope',
    '$stateParams',
    '$filter',
    '$window',
    '$state',
    'appSession',
    'abp.services.app.benefitGroup',
    'abp.services.app.commonLookup',
  ];

  function BenefitDetailPageController(
    $scope,
    $stateParams,
    $filter,
    $window,
    $state,
    appSession,
    benefitGroupSvc,
    commonLookupSvc
  ) {
    const vm = this;
    vm.loading = 0;
    vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
    vm.benefitId = $stateParams.inpatientBenefitGroupId;
    vm.serviceType = $stateParams.serviceType;
    vm.activeTab = 0;
    vm.isInsurance = false;
    
    vm.printAllTabs = printAllTabs;
    vm.back = back;

    function init() {
      getSupportPlan();
      getTenantCurrencyCode();
    }

    const ccyFilter = $filter('currencyFormat');
    const organizationId = parseInt(appSession.tenant.id, 10);
    const hospitalizationDetails = [
      new TreatmentModel(7, App.localize('Hospitalization'), 'fas fa-bed', true),
    ];
    const maternityDetails = [new TreatmentModel(8, App.localize('Maternity'), 'fas fa-bed', true)];

    function printAllTabs() {
      const benefitTabHeaders = $('#benefitDetails .benefitDetails')
        .map((i, e) => $(e).text())
        .get();
      const benefitTabContents = $('#benefitDetails .ibox-content')
        .map((i, e) => $(e).html())
        .get();

      // Replace SOB print values to include all tables

      const sobIndex = vm.isInsurance ? 2 : 1;

      benefitTabContents[benefitTabContents.length - sobIndex] = printSob();

      let printHtml = '';
      for (let i = 0; i < benefitTabHeaders.length; i += 1) {
        printHtml += `<h1>${benefitTabHeaders[i]}</h1>`;
        printHtml += `<div>${benefitTabContents[i]}</div>`;
      }

      $('#benefitDetailsPrint').html(printHtml);

      $window.print();

      $('#benefitDetailsPrint').empty();
    }

    function printSob() {
      // Retrieve tab headers
      const sobHeaders = $('#benefitDetails #principalDependent')
        .map((i, e) => $(e).text())
        .get();
      const principalHeaders = $('#benefitDetails #principal')
        .map((i, e) => $(e).text())
        .get();
      const dependentHeaders = $('#benefitDetails #dependent')
        .map((i, e) => $(e).text())
        .get();
      const principalDependent = [principalHeaders, dependentHeaders];

      // Retrieve table values
      const sobTabContents = $('#benefitDetails #sobDetail')
        .map((i, e) => $(e).html())
        .get();

      let printValue = '';
      let index = 0;

      for (let i = 0; i < sobHeaders.length; i += 1) {
        printValue += `<h2>${sobHeaders[i]}</h2>`;

        for (let j = 0; j < principalDependent[i].length; j += 1) {
          printValue += `<h3>${principalDependent[i][j]}<h3>`;

          if (index < sobTabContents.length)
            printValue += `<div>${sobTabContents[(index += 1)]}</div>`;
        }
      }

      return printValue;
    }

    function getSupportPlan() {
      vm.supportPlan = null;
      vm.loading += 1;
      benefitGroupSvc
        .getInpatientBenefitGroupForEdit({
          id: vm.benefitId,
          organizationId,
          serviceType: vm.serviceType,
        })
        .success((data) => {
          vm.optionalExclusions = data.optionalExclusions;
          vm.isHospitalization = data.benefitGroup.serviceType === 7;
          vm.benefitGroupName = data.benefitGroup.name;
          vm.isInsurance = !!data.benefitGroup.masterPolicyId;
          let benefitGroupType = '';
          switch (data.benefitGroup.serviceType) {
            case 7:
              benefitGroupType = App.localize('Hospitalization');
              break;
            case 8:
              benefitGroupType = App.localize('Maternity');
              break;
            default:
              break;
          }
          vm.benefitGroupType = benefitGroupType;

          vm.supportPlan = new BenefitGroupModel(data.benefitGroup);
          vm.supportPlan.organizationId = organizationId;
          vm.supportPlan.isInsurance = vm.isInsurance;
          vm.supportPlan.masterPolicy = data.masterPolicy;
          vm.supportPlan.insurer = data.newInsurer;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getTenantCurrencyCode() {
      vm.loading += 1;
      commonLookupSvc
        .getTenantCurrencyCode()
        .success((data) => {
          vm.currencyCode = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function back() {
      const state = vm.isInsurance ? 'corporate.insurancePlans' : 'corporate.inpatientBenefitGroup';
      $state.go(state);
    }

    function automap(source, target) {
      _.forIn(source, (v, k) => {
        target[k] = source[k];
      });
    }

    function initializeScheduleOfBenefit(thisSettings, dtoSettings) {
      // Special room and board

      thisSettings.icuRoomAndBoard.amountType = dtoSettings.icuRoomAndBoard.isAsCharged ? 0 : 1;

      // Lodging/bed

      thisSettings.childGuardianBenefit.amountType = dtoSettings.childGuardianBenefit.isAsCharged
        ? 0
        : 1;
      if (!thisSettings.childGuardianBenefit.isCovered) {
        thisSettings.childGuardianBenefit.amountType = 2;
      }

      // Admission charges

      thisSettings.hospitalCharges.isFixedLimit = dtoSettings.hospitalCharges.isFixedLimit ? 1 : 0;
      thisSettings.hospitalCharges.surgicalFee.amountType = dtoSettings.hospitalCharges.surgicalFee
        .isAsCharged
        ? 0
        : 1;
      thisSettings.hospitalCharges.anaesthetistFee.amountType = dtoSettings.hospitalCharges
        .anaesthetistFee.isAsCharged
        ? 0
        : 1;
      thisSettings.hospitalCharges.operatingTheatre.amountType = dtoSettings.hospitalCharges
        .operatingTheatre.isAsCharged
        ? 0
        : 1;
      thisSettings.hospitalCharges.hospitalSuppliesAndServices.amountType = dtoSettings
        .hospitalCharges.hospitalSuppliesAndServices.isAsCharged
        ? 0
        : 1;

      // Ambulance fee

      thisSettings.ambulanceFee.amountType = dtoSettings.ambulanceFee.isAsCharged ? 0 : 1;
      if (!thisSettings.ambulanceFee.isCovered) {
        thisSettings.ambulanceFee.amountType = 2;
      }

      // Organ transplant

      thisSettings.organTransplant.amountType = dtoSettings.organTransplant.isAsCharged ? 0 : 1;
      if (!thisSettings.organTransplant.isCovered) {
        thisSettings.organTransplant.amountType = 2;
      }
      thisSettings.organTransplant.maxDaysTimesType = dtoSettings.organTransplant.isUnlimited
        ? 1
        : 0;

      // Pre-hospitalization treatment

      thisSettings.preHospitalizationTreatment.isCovered = dtoSettings.preHospitalizationTreatment
        .isCovered
        ? 1
        : 0;

      // Pre-hospitalization specialist consultation

      thisSettings.specialistConsultation.maxDaysTimesType = dtoSettings.specialistConsultation
        .isUnlimited
        ? 1
        : 0;

      // Surgical opinion

      thisSettings.surgicalOpinion.amountType = dtoSettings.surgicalOpinion.isAsCharged ? 0 : 1;
      if (!thisSettings.surgicalOpinion.isCovered) {
        thisSettings.surgicalOpinion.amountType = 2;
      }
      thisSettings.surgicalOpinion.maxDaysTimesType = dtoSettings.surgicalOpinion.isUnlimited
        ? 1
        : 0;

      // post-hospitalization treatment

      thisSettings.postHospitalizationTreatment.isCovered = dtoSettings.postHospitalizationTreatment
        .isCovered
        ? 1
        : 0;

      // Follow-up treatment

      thisSettings.followUpTreatment.amountType = dtoSettings.followUpTreatment.isAsCharged ? 0 : 1;

      // Self-pay

      thisSettings.medicalReport.amountType = dtoSettings.medicalReport.isAsCharged ? 0 : 1;

      // Outpatient cancer treatment

      thisSettings.outpatientCancerTreatment.amountType = dtoSettings.outpatientCancerTreatment
        .isCovered
        ? 0
        : 1;

      // Outpatient kidney dialysis treatment

      thisSettings.outpatientKidneyDialysisTreatment.amountType = dtoSettings
        .outpatientKidneyDialysisTreatment.isCovered
        ? 0
        : 1;
    }

    function BenefitGroupModel(dto) {
      // Basic properties

      this.id = 0;
      this.organizationId = vm.organizationId;
      this.name = '';
      this.displayName = '';

      // Benefits

      this.principal = vm.isHospitalization ? hospitalizationDetails : maternityDetails;
      this.dependent = vm.isHospitalization ? hospitalizationDetails : maternityDetails;

      // Benefit Modifiers

      this.modifiers = [];

      // Benefit summaries

      this.principalSummaries = [];
      this.showPrincipalFootnote = false;
      this.dependentSummaries = [];
      this.showDependentFootnote = false;

      // Functions

      this.addModifier = () => {
        const modifier = new Modifier(this);
        if (vm.isHospitalization) {
          vm.supportPlan.hospitalizationSetting.modifiers.push(modifier);
        } else {
          vm.supportPlan.maternitySetting.modifiers.push(modifier);
        }
      };

      this.removeModifier = (index) => {
        abp.message.confirm(
          App.localize('DeleteBenefitModifierWarningMessage'),
          App.localize('AreYouSure'),
          (d) => {
            if (d) {
              $scope.$apply(() => {
                if (vm.isHospitalization) {
                  vm.supportPlan.hospitalizationSetting.modifiers.splice(index, 1);
                } else {
                  vm.supportPlan.maternitySetting.modifiers.splice(index, 1);
                }
                this.refreshResult();
              });
              return true;
            }
            return false;
          }
        );
      };

      this.addCoPay = () => {
        const coPay = new CoPay(this);
        if (vm.isHospitalization) {
          this.hospitalizationSetting.coPays.push(coPay);
        } else {
          this.maternitySetting.coPays.push(coPay);
        }
      };

      this.removeCoPay = (index) => {
        abp.message.confirm(
          App.localize('DeleteBenefitModifierWarningMessage'),
          App.localize('AreYouSure'),
          (d) => {
            if (d) {
              $scope.$apply(() => {
                if (vm.isHospitalization) {
                  this.hospitalizationSetting.coPays.splice(index, 1);
                  vm.hospitalizationCopayForm.$setDirty();
                } else {
                  this.maternitySetting.coPays.splice(index, 1);
                  vm.maternityCopayForm.$setDirty();
                }
                this.refreshResult();
              });
              return true;
            }
            return false;
          }
        );
      };

      this.refreshResult = () => {
        const principalSummaries = [];
        const dependentSummaries = [];
        let showPrincipalFootnote = false;
        let showDependentFootnote = false;

        let coverDependent =
          (this.hospitalizationSetting && !!this.hospitalizationSetting.hasDependentCovered) ||
          (this.maternitySetting && !!this.maternitySetting.isSpouseCovered);
        const principal = _.map(
          _.filter(this.principal, 'valid'),
          (x) => new BenefitResult(x, true, true)
        );
        const dependent = coverDependent
          ? _.map(_.filter(this.dependent, 'valid'), (x) => new BenefitResult(x, true, true))
          : [];
        if (!dependent.length) {
          coverDependent = false;
        }
        const coverPrincipal = principal.length > 0;

        // Group result into stacks

        let modifiers = [];
        if (typeof vm.isHospitalization !== 'undefined' && vm.isHospitalization !== null) {
          modifiers = vm.isHospitalization
            ? this.hospitalizationSetting.modifiers
            : this.maternitySetting.modifiers;
        }

        _.each(modifiers, (mod) => {
          if (mod.cycle === 4 && mod.type !== 0) {
            mod.cycle = 3;
          }
        });

        _.each(
          _.groupBy(modifiers, (x) => {
            const interval = x.cycle === 0 ? x.interval : 1;
            return `${x.type}:${interval}:${x.cycle}`;
          }),
          (values) => {
            _.each(values, (modifier) => {
              const principalPortion = [];
              const dependentPortion = [];

              const beneficiary = coverDependent ? modifier.beneficiary : 1;
              let poolMode = coverDependent ? modifier.poolMode : 2;

              const includesPrincipal = [1, 3].includes(beneficiary);
              const includesDependent = [2, 3].includes(beneficiary);

              _.each(modifier.treatments, (t) => {
                let benefit;
                if (coverPrincipal && includesPrincipal > 0) {
                  benefit = _.find(principal, (x) => x.treatment.id === t.treatment.id);
                  if (benefit) {
                    if (modifier.type === 0) {
                      benefit.unlimitedBudget = false;
                    } else if (modifier.type === 1) {
                      benefit.unlimitedVisit = false;
                    }
                    principalPortion.push(t.treatment);
                  }
                }
                if (coverDependent && includesDependent > 0) {
                  benefit = _.find(dependent, (x) => x.treatment.id === t.treatment.id);
                  if (benefit) {
                    if (modifier.type === 0) {
                      benefit.unlimitedBudget = false;
                    } else if (modifier.type === 1) {
                      benefit.unlimitedVisit = false;
                    }
                    dependentPortion.push(t.treatment);
                  }
                }
              });

              if (principalPortion.length || dependentPortion.length) {
                const uniquePortion = _.uniqBy(_.concat(principalPortion, dependentPortion), 'id');
                const modifierTreatmentNames = _.join(_.map(uniquePortion, 'name'), '+');
                const principalTreatmentNames = _.join(_.map(principalPortion, 'name'), '+');
                const dependentTreatmentNames = _.join(_.map(dependentPortion, 'name'), '+');

                if (poolMode === 0 && (!principalPortion.length || !dependentPortion.length)) {
                  poolMode = 2;
                }

                let principalSummaryRecord = null;
                if (principalTreatmentNames) {
                  principalSummaryRecord = _.find(
                    principalSummaries,
                    (x) => x.key === principalTreatmentNames
                  );

                  if (!principalSummaryRecord) {
                    principalSummaries.push(
                      (principalSummaryRecord = new BenefitSummary(principalTreatmentNames))
                    );
                  }
                }

                let dependentSummaryRecord = null;
                if (dependentTreatmentNames) {
                  dependentSummaryRecord = _.find(
                    dependentSummaries,
                    (x) => x.key === dependentTreatmentNames
                  );

                  if (!dependentSummaryRecord) {
                    dependentSummaries.push(
                      (dependentSummaryRecord = new BenefitSummary(dependentTreatmentNames))
                    );
                  }
                }

                // Get modifier description

                let str = '';
                const strValue = _.isNil(modifier.value) ? '?' : modifier.value;
                switch (modifier.type) {
                  case 0:
                    str += ` ${ccyFilter(modifier.value, vm.currencyCode)}`;
                    break;
                  case 1:
                    str += ` ${strValue} ${App.localize('VisitLimit').toLowerCase()}`;
                    break;
                  case 2:
                    str += ` ${ccyFilter(modifier.value, vm.currencyCode)} (${App.localize(
                      'BudgetOverdraft'
                    ).toLowerCase()})`;
                    break;
                  case 3:
                    str += ` ${strValue}${App.localize('VisitOverdraft').toLowerCase()}`;
                    break;
                  default:
                    break;
                }

                let cycle = '';
                switch (modifier.cycle) {
                  case 0:
                    cycle = App.localize('EveryXYears', modifier.interval).toLowerCase();
                    break;
                  case 1:
                    cycle = App.localize('Annually').toLowerCase();
                    break;
                  case 2:
                    cycle = App.localize('PerEmploymentContract').toLowerCase();
                    break;
                  default:
                    break;
                }
                str += ` ${cycle}`;

                let allStr = '';
                let principalStr = '';
                let dependentStr = '';
                if (poolMode === 0) {
                  allStr = str;
                  if (principalTreatmentNames !== dependentTreatmentNames) {
                    if (principalPortion.length) {
                      allStr += ` (${App.localize('Principal')}: ${principalTreatmentNames})`;
                    }
                    if (dependentPortion.length) {
                      allStr += ` (${App.localize('Dependent')}: ${dependentTreatmentNames})`;
                    }
                  }

                  if (principalSummaryRecord) {
                    principalSummaryRecord.addItem(
                      modifier.type,
                      cycle,
                      '[1]',
                      modifier.value || 0
                    );
                    showPrincipalFootnote = true;
                  }
                  if (dependentSummaryRecord) {
                    dependentSummaryRecord.addItem(
                      modifier.type,
                      cycle,
                      '[1]',
                      modifier.value || 0
                    );
                    showDependentFootnote = true;
                  }
                } else if (poolMode === 1) {
                  principalStr = '';
                  if (principalPortion.length) {
                    principalStr = str;
                    if (principalTreatmentNames !== modifierTreatmentNames) {
                      principalStr += ` (${principalTreatmentNames})`;
                    }
                  }

                  dependentStr = '';
                  if (dependentPortion.length) {
                    dependentStr = str;
                    if (dependentTreatmentNames !== modifierTreatmentNames) {
                      dependentStr += ` (${dependentTreatmentNames})`;
                    }
                  }

                  if (principalSummaryRecord) {
                    principalSummaryRecord.addItem(modifier.type, cycle, '', modifier.value || 0);
                  }
                  if (dependentSummaryRecord) {
                    dependentSummaryRecord.addItem(modifier.type, cycle, '', modifier.value || 0);
                  }
                } else if (poolMode === 2) {
                  principalStr = '';
                  if (principalPortion.length) {
                    principalStr = str;
                    if (principalTreatmentNames !== modifierTreatmentNames) {
                      principalStr += ` (${principalTreatmentNames})`;
                    }
                  }

                  dependentStr = '';
                  if (dependentPortion.length) {
                    dependentStr = str;
                    if (dependentTreatmentNames !== modifierTreatmentNames) {
                      dependentStr += ` (${dependentTreatmentNames})`;
                    }
                  }

                  if (principalSummaryRecord) {
                    principalSummaryRecord.addItem(modifier.type, cycle, '', modifier.value || 0);
                  }
                  if (dependentSummaryRecord) {
                    dependentSummaryRecord.addItem(
                      modifier.type,
                      cycle,
                      '[2]',
                      modifier.value || 0
                    );
                    showDependentFootnote = true;
                  }
                }
              }
            });
          }
        );

        const copaymentModifiers = vm.isHospitalization
          ? this.hospitalizationSetting.coPays
          : this.maternitySetting.coPays;
        let showPrincipalCopayFootnote = false;
        let showDependentCopayFootnote = false;

        if (_.find(copaymentModifiers, { beneficiary: 3 })) {
          showPrincipalCopayFootnote = true;
          showDependentCopayFootnote = true;
        } else if (_.find(copaymentModifiers, { beneficiary: 2 })) {
          showDependentCopayFootnote = true;
        } else if (_.find(copaymentModifiers, { beneficiary: 1 })) {
          showPrincipalCopayFootnote = true;
        }

        // Print summary

        principal.forEach((x) => {
          if (x.unlimitedVisit || x.unlimitedBudget) {
            let summary = _.find(principalSummaries, (y) => y.key === x.treatment.name);
            if (!summary) {
              principalSummaries.push((summary = new BenefitSummary(x.treatment.name)));
            }

            if (x.unlimitedBudget && x.unlimitedVisit) {
              summary.addText(App.localize('Unlimited'));
            } else {
              if (x.unlimitedBudget) {
                summary.addText(App.localize('UnlimitedBudget'));
              }
              if (x.unlimitedVisit) {
                summary.addText(App.localize('UnlimitedVisit'));
              }
            }
          }
        });
        this.principalSummaries = principalSummaries;
        this.showPrincipalFootnote = showPrincipalFootnote;
        this.showPrincipalCopayFootnote = showPrincipalCopayFootnote;

        dependent.forEach((x) => {
          if (x.unlimitedVisit || x.unlimitedBudget) {
            let summary = _.find(dependentSummaries, (y) => y.key === x.treatment.name);
            if (!summary) {
              dependentSummaries.push((summary = new BenefitSummary(x.treatment.name)));
            }
            if (x.unlimitedBudget && x.unlimitedVisit) {
              summary.addText(App.localize('Unlimited'));
            } else {
              if (x.unlimitedBudget) {
                summary.addText(App.localize('UnlimitedBudget'));
              }
              if (x.unlimitedVisit) {
                summary.addText(App.localize('UnlimitedVisit'));
              }
            }
          }
        });
        this.dependentSummaries = dependentSummaries;
        this.showDependentFootnote = showDependentFootnote;
        this.showDependentCopayFootnote = showDependentCopayFootnote;
      };

      // Initialization

      if (dto) {
        automap(dto, this);

        // Inpatient or maternity settings.

        if (this.serviceType === 7) {
          // Basics

          this.hospitalizationSetting.hasDependentCovered = dto.hospitalizationSetting
            .hasDependentCovered
            ? 1
            : 0;
          this.hospitalizationSetting.isAccidentAdmission =
            dto.hospitalizationSetting.admissionWaitingAccidentDays > 0 ? 1 : 0;
          this.hospitalizationSetting.isIllnessAdmission =
            dto.hospitalizationSetting.admissionWaitingIllnessDays > 0 ? 1 : 0;
          this.hospitalizationSetting.isPreExisting =
            dto.hospitalizationSetting.admissionWaitingPreExistingDays > 0 ? 1 : 0;
          this.hospitalizationSetting.isNonAccidentalIllness =
            dto.hospitalizationSetting.admissionWaitingNonAccidentalIllnessDays > 0 ? 1 : 0;
          this.hospitalizationSetting.isDefaultExclusionsCovered = dto.hospitalizationSetting
            .isDefaultExclusionsCovered
            ? 1
            : 0;

          this.hospitalizationSetting.coveredOptionalExclusions = buildExclusionTypeList(
            vm.optionalExclusions,
            dto.hospitalizationSetting.coveredOptionalExclusions
          );

          // Benefits

          const clonedHospitalizationModifiers = dto.hospitalizationSetting.modifiers.slice(0);
          this.hospitalizationSetting.modifiers = [];
          _.each(clonedHospitalizationModifiers, (x) => {
            this.hospitalizationSetting.modifiers.push(new Modifier(this, x));
          });

          // Cost sharing
          this.hospitalizationSetting.isCoInsurance = dto.hospitalizationSetting.isCoInsurance;

          const clonedHospitalizationCoPays = dto.hospitalizationSetting.coPays
            ? dto.hospitalizationSetting.coPays.slice(0)
            : null;
          this.hospitalizationSetting.coPays = [];
          _.each(clonedHospitalizationCoPays, (x) => {
            this.hospitalizationSetting.coPays.push(new CoPay(this, x));
          });

          // Schedule of benefit

          this.hospitalizationSetting.enableDependentSetting = 0;
          initializeScheduleOfBenefit(
            this.hospitalizationSetting.principalScheduleOfBenefit,
            dto.hospitalizationSetting.principalScheduleOfBenefit
          );

          if (dto.hospitalizationSetting.dependentScheduleOfBenefit !== null) {
            initializeScheduleOfBenefit(
              this.hospitalizationSetting.dependentScheduleOfBenefit,
              dto.hospitalizationSetting.dependentScheduleOfBenefit
            );
          }
        } else {
          // Basics

          this.maternitySetting.isSpouseCovered = dto.maternitySetting.isSpouseCovered ? 1 : 0;
          this.maternitySetting.isHasMotherAgeLimit = dto.maternitySetting.motherMaxAge > 0 ? 1 : 0;
          this.maternitySetting.isMaternitybenefits =
            dto.maternitySetting.admissionWaitingDays > 0 ? 1 : 0;
          this.maternitySetting.isMaternitybenefits =
            dto.maternitySetting.admissionWaitingDays > 0 ? 1 : 0;
          this.maternitySetting.isUnlimitedDelivery =
            dto.maternitySetting.deliveryLimit === 0 ? 1 : 0;

          // Benefits

          const clonedMaternityModifiers = dto.maternitySetting.modifiers.slice(0);
          this.maternitySetting.modifiers = [];
          _.each(clonedMaternityModifiers, (x) => {
            this.maternitySetting.modifiers.push(new Modifier(this, x));
          });

          // Cost sharing

          this.maternitySetting.isCoInsurance = dto.maternitySetting.isCoInsurance;

          const clonedMaternityCoPays = dto.maternitySetting.coPays
            ? dto.maternitySetting.coPays.slice(0)
            : null;
          this.maternitySetting.coPays = [];
          _.each(clonedMaternityCoPays, (x) => {
            this.maternitySetting.coPays.push(new CoPay(this, x));
          });

          // Normal delivery

          this.maternitySetting.normalDelivery.amountType = dto.maternitySetting.normalDelivery
            .isAsCharged
            ? 0
            : 1;
          if (!this.maternitySetting.normalDelivery.isCovered) {
            this.maternitySetting.normalDelivery.amountType = 2;
          }
          this.maternitySetting.normalDelivery.maxDaysTimesType = dto.maternitySetting
            .normalDelivery.isUnlimited
            ? 1
            : 0;

          // Caesarean delivery

          this.maternitySetting.caesareanDelivery.amountType = dto.maternitySetting
            .caesareanDelivery.isAsCharged
            ? 0
            : 1;
          if (!this.maternitySetting.caesareanDelivery.isCovered) {
            this.maternitySetting.caesareanDelivery.amountType = 2;
          }
          this.maternitySetting.caesareanDelivery.maxDaysTimesType = dto.maternitySetting
            .caesareanDelivery.isUnlimited
            ? 1
            : 0;

          // Normal delivery for twins and above

          this.maternitySetting.normalDeliveryTwinsAndAbove.amountType = dto.maternitySetting
            .normalDeliveryTwinsAndAbove.isAsCharged
            ? 0
            : 1;
          if (!this.maternitySetting.normalDeliveryTwinsAndAbove.isCovered) {
            this.maternitySetting.normalDeliveryTwinsAndAbove.amountType = 2;
          }
          this.maternitySetting.normalDeliveryTwinsAndAbove.maxDaysTimesType = dto.maternitySetting
            .normalDeliveryTwinsAndAbove.isUnlimited
            ? 1
            : 0;

          // Caesarean delivery for twins and above

          this.maternitySetting.caesareanDeliveryTwinsAndAbove.amountType = dto.maternitySetting
            .caesareanDeliveryTwinsAndAbove.isAsCharged
            ? 0
            : 1;
          if (!this.maternitySetting.caesareanDeliveryTwinsAndAbove.isCovered) {
            this.maternitySetting.caesareanDeliveryTwinsAndAbove.amountType = 2;
          }
          this.maternitySetting.caesareanDeliveryTwinsAndAbove.maxDaysTimesType = dto
            .maternitySetting.caesareanDeliveryTwinsAndAbove.isUnlimited
            ? 1
            : 0;

          // Pre-natal check-up

          this.maternitySetting.preNatalCheckUp.isCovered = dto.maternitySetting.preNatalCheckUp
            .isCovered
            ? 1
            : 0;
          this.maternitySetting.preNatalCheckUp.amountType = dto.maternitySetting.preNatalCheckUp
            .isAsCharged
            ? 0
            : 1;
          this.maternitySetting.preNatalCheckUp.maxDaysTimesType = dto.maternitySetting
            .preNatalCheckUp.isUnlimited
            ? 1
            : 0;

          // Post-natal follow-up

          this.maternitySetting.postNatalFollowUp.isCovered = dto.maternitySetting.postNatalFollowUp
            .isCovered
            ? 1
            : 0;
          this.maternitySetting.postNatalFollowUp.amountType = dto.maternitySetting
            .postNatalFollowUp.isAsCharged
            ? 0
            : 1;
          this.maternitySetting.postNatalFollowUp.maxDaysTimesType = dto.maternitySetting
            .postNatalFollowUp.isUnlimited
            ? 1
            : 0;

          // Miscarriage

          this.maternitySetting.miscarriage.amountType = dto.maternitySetting.miscarriage
            .isAsCharged
            ? 0
            : 1;
          this.maternitySetting.miscarriage.maxDaysTimesType = dto.maternitySetting.miscarriage
            .isUnlimited
            ? 1
            : 0;

          // Covers pregnancy related complications

          this.maternitySetting.isOptionalExclusionsCovered =
            dto.maternitySetting.coveredOptionalExclusions &&
            dto.maternitySetting.coveredOptionalExclusions.length > 0
              ? 1
              : 0;
          this.maternitySetting.coveredOptionalExclusions = buildExclusionTypeList(
            vm.optionalExclusions,
            dto.maternitySetting.coveredOptionalExclusions
          );

          // Neo-natal

          this.maternitySetting.neoNatal.isCovered = dto.maternitySetting.neoNatal.isCovered
            ? 1
            : 0;
        }
      }

      this.refreshResult();

      // Post method

      this.toDto = () => {
        function getOptionalExclusionIds(exclusions) {
          return _(exclusions).filter('valid').map('id').value();
        }

        function getModifierDto(modifiers) {
          return _(modifiers)
            .map((m) => m.toDto())
            .value();
        }

        function getCoPayDto(coPays) {
          return _(coPays)
            .map((m) => m.toDto())
            .value();
        }

        function getScheduleOfBenefitDto(setting) {
          return {
            roomAndBoardAmount: setting.roomAndBoard.amount,
            icuRoomAndBoard: {
              isAsCharged: setting.icuRoomAndBoard.amountType === 0,
              amount: setting.icuRoomAndBoard.amount,
            },
            childGuardianBenefit: {
              isAsCharged: setting.childGuardianBenefit.amountType === 0,
              amount: setting.childGuardianBenefit.amount,
              isCovered: setting.childGuardianBenefit.amountType !== 2,
            },
            inHospitalPhysicianVisitPerDay: setting.inHospitalPhysicianVisitPerDay,
            hospitalCharges: {
              isFixedLimit: setting.hospitalCharges.isFixedLimit === 1,
              fixedLimitAmount: setting.hospitalCharges.fixedLimitAmount,
              surgicalFee: {
                isAsCharged: setting.hospitalCharges.surgicalFee.amountType === 0,
                amount: setting.hospitalCharges.surgicalFee.amount,
              },
              anaesthetistFee: {
                isAsCharged: setting.hospitalCharges.anaesthetistFee.amountType === 0,
                amount: setting.hospitalCharges.anaesthetistFee.amount,
              },
              operatingTheatre: {
                isAsCharged: setting.hospitalCharges.operatingTheatre.amountType === 0,
                amount: setting.hospitalCharges.operatingTheatre.amount,
              },
              hospitalSuppliesAndServices: {
                isAsCharged: setting.hospitalCharges.hospitalSuppliesAndServices.amountType === 0,
                amount: setting.hospitalCharges.hospitalSuppliesAndServices.amount,
              },
            },
            ambulanceFee: {
              isAsCharged: setting.ambulanceFee.amountType === 0,
              amount: setting.ambulanceFee.amount,
              isCovered: setting.ambulanceFee.amountType !== 2,
            },
            medicalReport: {
              isAsCharged: setting.medicalReport.amountType === 0,
              amount: setting.medicalReport.amount,
            },
            organTransplant: {
              isAsCharged: setting.organTransplant.amountType === 0,
              amount: setting.organTransplant.amount,
              isCovered: setting.organTransplant.amountType !== 2,
              isUnlimited: setting.organTransplant.maxDaysTimesType === 1,
              coveredTimes: setting.organTransplant.coveredTimes,
            },
            preHospitalizationTreatment: {
              isCovered: setting.preHospitalizationTreatment.isCovered === 1,
              coveredDays: setting.preHospitalizationTreatment.coveredDays,
            },
            specialistConsultation: {
              isUnlimited: setting.specialistConsultation.maxDaysTimesType === 1,
              coveredTimes: setting.specialistConsultation.coveredTimes,
            },
            surgicalOpinion: {
              isAsCharged: setting.surgicalOpinion.amountType === 0,
              amount: setting.surgicalOpinion.amount,
              isCovered: setting.surgicalOpinion.amountType !== 2,
              isUnlimited: setting.surgicalOpinion.maxDaysTimesType === 1,
              coveredTimes: setting.surgicalOpinion.coveredTimes,
            },
            postHospitalizationTreatment: {
              isCovered: setting.postHospitalizationTreatment.isCovered === 1,
              coveredDays: setting.postHospitalizationTreatment.coveredDays,
            },
            followUpTreatment: {
              isAsCharged: setting.followUpTreatment.amountType === 0,
              amount: setting.followUpTreatment.amount,
            },
            outpatientCancerTreatment: {
              isCovered: setting.outpatientCancerTreatment.amountType !== 1,
              amount: setting.outpatientCancerTreatment.amount,
            },
            outpatientKidneyDialysisTreatment: {
              isCovered: setting.outpatientKidneyDialysisTreatment.amountType !== 1,
              amount: setting.outpatientKidneyDialysisTreatment.amount,
            },
          };
        }

        function getMaternityBenefitSettingsDto(settings) {
          return {
            isSpouseCovered: settings.isSpouseCovered === 1,
            admissionWaitingDays:
              settings.isMaternitybenefits === 1 ? settings.admissionWaitingDays : 0,
            motherMaxAge: settings.isHasMotherAgeLimit === 1 ? settings.motherMaxAge : 0,
            isUnlimitedDelivery: settings.isUnlimitedDelivery === 1,
            deliveryLimit: settings.isUnlimitedDelivery === 0 ? settings.deliveryLimit : 0,
            isDefaultExclusionsCovered: settings.isDefaultExclusionsCovered === 1,
            exclusionVersionId: settings.exclusionVersionId,
            coveredOptionalExclusions:
              settings.isOptionalExclusionsCovered === 1
                ? getOptionalExclusionIds(settings.coveredOptionalExclusions)
                : [],
            copays: getCoPayDto(settings.coPays),
            modifiers: getModifierDto(settings.modifiers),
            normalDelivery: {
              isAsCharged: settings.normalDelivery.amountType === 0,
              amount: settings.normalDelivery.amount,
              isCovered: settings.normalDelivery.amountType !== 2,
              isUnlimited: settings.normalDelivery.maxDaysTimesType === 1,
              coveredTimes: settings.normalDelivery.coveredTimes,
              coveredCycle: settings.normalDelivery.coveredCycle,
            },
            caesareanDelivery: {
              isAsCharged: settings.caesareanDelivery.amountType === 0,
              amount: settings.caesareanDelivery.amount,
              isCovered: settings.caesareanDelivery.amountType !== 2,
              isUnlimited: settings.caesareanDelivery.maxDaysTimesType === 1,
              coveredTimes: settings.caesareanDelivery.coveredTimes,
              coveredCycle: settings.caesareanDelivery.coveredCycle,
            },
            normalDeliveryTwinsAndAbove: {
              isAsCharged: settings.normalDeliveryTwinsAndAbove.amountType === 0,
              amount: settings.normalDeliveryTwinsAndAbove.amount,
              isCovered: settings.normalDeliveryTwinsAndAbove.amountType !== 2,
              isUnlimited: settings.normalDeliveryTwinsAndAbove.maxDaysTimesType === 1,
              coveredTimes: settings.normalDeliveryTwinsAndAbove.coveredTimes,
              coveredCycle: settings.normalDeliveryTwinsAndAbove.coveredCycle,
            },
            caesareanDeliveryTwinsAndAbove: {
              isAsCharged: settings.caesareanDeliveryTwinsAndAbove.amountType === 0,
              amount: settings.caesareanDeliveryTwinsAndAbove.amount,
              isCovered: settings.caesareanDeliveryTwinsAndAbove.amountType !== 2,
              isUnlimited: settings.caesareanDeliveryTwinsAndAbove.maxDaysTimesType === 1,
              coveredTimes: settings.caesareanDeliveryTwinsAndAbove.coveredTimes,
              coveredCycle: settings.caesareanDeliveryTwinsAndAbove.coveredCycle,
            },
            preNatalCheckUp: {
              isCovered: settings.preNatalCheckUp.isCovered === 1,
              coveredDays: settings.preNatalCheckUp.coveredDays,
              isAsCharged: settings.preNatalCheckUp.amountType === 0,
              amount: settings.preNatalCheckUp.amount,
              isUnlimited: settings.preNatalCheckUp.maxDaysTimesType === 1,
              coveredTimes: settings.preNatalCheckUp.coveredTimes,
              coveredCycle: settings.preNatalCheckUp.coveredCycle,
            },
            postNatalFollowUp: {
              isCovered: settings.postNatalFollowUp.isCovered === 1,
              coveredDays: settings.postNatalFollowUp.coveredDays,
              isAsCharged: settings.postNatalFollowUp.amountType === 0,
              amount: settings.postNatalFollowUp.amount,
              isUnlimited: settings.postNatalFollowUp.maxDaysTimesType === 1,
              coveredTimes: settings.postNatalFollowUp.coveredTimes,
            },
            miscarriage: {
              isAsCharged: settings.miscarriage.amountType === 0,
              amount: settings.miscarriage.amount,
              isCovered: settings.miscarriage.amountType !== 2,
            },
            neoNatal: {
              isCovered: settings.neoNatal.isCovered === 1,
              coveredDays: settings.neoNatal.coveredDays,
              newBornNicuAmount: settings.neoNatal.newBornNicuAmount,
              newBornIncubationAmount: settings.neoNatal.newBornIncubationAmount,
              newBornPhotoTherapyAmount: settings.neoNatal.newBornPhotoTherapyAmount,
            },
            isCoInsurance: settings.isCoInsurance,
          };
        }

        function getHospitalizationBenefitSettingsDto(settings, isCreate) {
          const principalScheduleOfBenefit = getScheduleOfBenefitDto(
            settings.principalScheduleOfBenefit
          );
          const dependentScheduleOfBenefit =
            isCreate && settings.enableDependentSetting === 0
              ? principalScheduleOfBenefit
              : getScheduleOfBenefitDto(settings.dependentScheduleOfBenefit);

          return {
            hasDependentCovered:
              settings.hasDependentCovered === 1 ? settings.hasDependentCovered : 0,
            admissionWaitingAccidentDays:
              settings.isAccidentAdmission === 1 ? settings.admissionWaitingAccidentDays : 0,
            admissionWaitingIllnessDays:
              settings.isIllnessAdmission === 1 ? settings.admissionWaitingIllnessDays : 0,
            admissionWaitingPreExistingDays:
              settings.isPreExisting === 1 ? settings.admissionWaitingPreExistingDays : 0,
            admissionWaitingNonAccidentalIllnessDays:
              settings.isNonAccidentalIllness === 1
                ? settings.admissionWaitingNonAccidentalIllnessDays
                : 0,
            exclusionVersionId: settings.exclusionVersionId,
            isDefaultExclusionsCovered: settings.isDefaultExclusionsCovered === 1,
            coveredOptionalExclusions: getOptionalExclusionIds(settings.coveredOptionalExclusions),
            isCoInsurance: settings.isCoInsurance,
            copays: getCoPayDto(settings.coPays),
            modifiers: getModifierDto(settings.modifiers),
            principalScheduleOfBenefit,
            dependentScheduleOfBenefit:
              settings.hasDependentCovered === 1 ? dependentScheduleOfBenefit : null,
          };
        }

        let hospitalizationSetting = null;
        let maternitySettings = null;
        if (vm.isHospitalization) {
          hospitalizationSetting = getHospitalizationBenefitSettingsDto(
            this.hospitalizationSetting,
            vm.isCreate
          );
        } else {
          maternitySettings = getMaternityBenefitSettingsDto(this.maternitySetting);
        }

        return {
          id: this.id,
          tenantId: this.tenantId,
          serviceType: this.serviceType,
          name: this.name,
          displayName: this.displayName,
          hospitalizationSetting,
          maternitySetting: maternitySettings,
        };
      };
    }

    function ExclusionModel(id, name, valid) {
      this.id = id;
      this.name = name;
      this.valid = valid;
    }

    function buildExclusionTypeList(optionalExclusions, coveredOptionalExclusions) {
      const exclusions = [];

      const covered = coveredOptionalExclusions || [];

      _.each(optionalExclusions, (exc) => {
        const isCovered = _.indexOf(covered, exc.value) >= 0;
        exclusions.push(new ExclusionModel(exc.value, exc.name, isCovered));
      });

      return exclusions;
    }

    function TreatmentModel(id, name, icon, valid) {
      this.id = id;
      this.name = name;
      this.icon = icon;
      this.valid = valid;
    }

    function TreatmentApplyModel(treatment, applicable) {
      this.treatment = treatment;
      this.applicable = applicable;
    }

    function BenefitResult(treatment, unlimitedBudget, unlimitedVisit) {
      this.treatment = treatment;
      this.unlimitedBudget = unlimitedBudget;
      this.unlimitedVisit = unlimitedVisit;
    }

    function BenefitSummaryItem(type, cycle, poolMode, value) {
      this.type = type;
      this.cycle = cycle;
      this.poolMode = poolMode;
      this.value = value;

      this.toString = () => {
        let str = '';
        const strValue = _.isNil(this.value) ? '?' : this.value;
        switch (this.type) {
          case 0:
            str += `${vm.currencyCode} ${strValue}`;
            break;
          case 1:
            str += `${strValue} ${this.value > 1 ? 'visits' : 'visit'}`;
            break;
          case 2:
            str += `${vm.currencyCode} ${strValue} overdraft`;
            break;
          case 3:
            str += `${strValue} overdraft ${this.value > 1 ? 'visits' : 'visit'}`;
            break;
          default:
            break;
        }

        str += ` ${this.cycle} ${this.poolMode}`;
        return str;
      };
    }

    function BenefitSummary(key, value) {
      this.items = [];
      this.texts = [];

      this.key = key;
      this.value = value;

      this.addItem = (type, cycle, poolMode, itemValue) => {
        const item = _.find(
          this.items,
          (x) => x.type === type && x.cycle === cycle && x.poolMode === poolMode
        );

        if (!item) {
          this.items.push(new BenefitSummaryItem(type, cycle, poolMode, itemValue));
        } else {
          item.value += itemValue;
        }
      };

      this.addText = (text) => {
        this.texts.push(text);
      };

      this.toString = () =>
        _.concat(
          _.map(this.items, (x) => x.toString()),
          this.texts
        ).join(', ');
    }

    function Modifier(bgModel, dto) {
      this.parent = bgModel;

      // Basic properties

      this.type = 0;
      this.cycle = 1;
      this.beneficiary = 3;
      this.poolMode = 0;
      this.value = null;
      this.interval = 2;

      // View properties

      this.show = true;
      this.description = '';

      // Treatment type mapping

      this.principalMap = _.keyBy(bgModel.principal, 'id');
      this.dependentMap = _.keyBy(bgModel.dependent, 'id');

      // Applicable treatment types

      const treatments = [];
      _.each(this.parent.principal, (e) => {
        const isValid = checkValid(e.id);
        treatments.push(
          new TreatmentApplyModel(new TreatmentModel(e.id, e.name, e.icon, isValid), isValid)
        );
      });
      this.treatments = treatments;

      // Private functions

      function checkValid(id) {
        switch (this.beneficiary) {
          case 3:
            return (
              this.principalMap[id].valid ||
              (this.parent.hasDependentCovered === 1 && this.dependentMap[id].valid)
            );
          case 1:
            return this.principalMap[id].valid;
          case 2:
            return this.dependentMap[id].valid;
          default:
            return false;
        }
      }

      function validateModifierRules() {
        // If modifier is not budget limit, cycle cannot be Per Visit.
        // Default to annually.

        if (this.type !== 0 && this.cycle === 4) {
          this.cycle = 1;
        }

        // If beneficiary is principal only, there is no pool to share.
        // If beneficiary is dependant only, split pool cannot be selected.
        // Default to individual pool.

        if (this.beneficiary === 1 || (this.beneficiary === 2 && this.poolMode === 2)) {
          this.poolMode = 1;
        }
      }

      // Public functions

      this.changed = () => {
        validateModifierRules();
        this.refreshTreatmentValidity();
        this.refreshDescription();
      };

      this.refreshTreatmentValidity = () => {
        _.each(this.treatments, (e) => {
          e.treatment.valid = checkValid(e.treatment.id);
        });
      };

      // Post method

      this.toDto = () => ({
        type: this.type,
        cycle: this.cycle,
        beneficiary: this.beneficiary,
        poolMode: this.poolMode,
        value: this.value,
        interval: this.interval,
      });

      this.refreshDescription = () => {
        const { type } = this;
        const { cycle } = this;
        const { interval } = this;
        const { beneficiary } = this;
        const { poolMode } = this;
        const { value } = this;
        const { treatmentTypes } = this;
        let desc = '';
        const ttNames = [];

        switch (cycle) {
          case 0:
            desc += `Every ${interval} year(s)`;
            break;
          case 1:
            desc += 'Every year';
            break;
          case 2:
            desc += 'Every month';
            break;
          case 3:
            desc += 'Everyday';
            break;
          case 4:
            desc += 'Every visit';
            break;
          default:
            break;
        }

        switch (type) {
          case 0:
          case 1:
            desc += ' limits ';
            break;
          case 2:
          case 3:
            desc += ' allows overdraft of ';
            break;
          default:
            break;
        }

        switch (type) {
          case 0:
          case 2:
            desc += `${vm.currencyCode} ${value}`;
            break;
          case 1:
          case 3:
            desc += `${value} visits`;
            break;
          default:
            break;
        }

        switch (beneficiary) {
          case 1:
            desc += ' for principal';
            break;
          case 2:
            desc += ' for dependants';
            break;
          case 3:
            desc += ' for principal & dependants';
            break;
          default:
            break;
        }

        switch (poolMode) {
          case 0:
            desc += ' where everyone share';
            break;
          case 1:
            desc += ' individually';
            break;
          case 2:
            desc += ' where dependents share';
            break;
          default:
            break;
        }

        if (treatmentTypes) {
          desc += ' on ';

          _.each(treatmentTypes, (isApplied, idStr) => {
            const id = parseInt(idStr, 10); // radix 10 added here
            if (isApplied) {
              const treatmentType = _.find(vm.treatmentTypes, (a) => a.id === id);
              if (type) {
                ttNames.push(treatmentType.name);
              }
            }
          });

          desc += ttNames.join(', ');
        }

        this.description = ttNames.length > 0 ? desc : 'Not applicable';
      };

      // Initialization

      if (dto) {
        automap(dto, this);
        this.refreshTreatmentValidity();
      }

      this.refreshDescription();
    }

    function CoPay(bgModel, dto) {
      this.parent = bgModel;

      // Basic properties

      this.beneficiary = 3;
      this.isPercentage = true;
      this.value = null;

      // View properties

      this.show = true;

      // Treatment type mapping

      this.principalMap = _.keyBy(bgModel.principalBenefits, 'id');
      this.dependentMap = _.keyBy(bgModel.dependentBenefits, 'id');

      // Applicable treatment types

      const treatments = [];
      _.each(this.parent.principalBenefits, (e) => {
        const isValid = checkValid(e.id);
        treatments.push(
          new TreatmentApplyModel(new TreatmentModel(e.id, e.name, e.icon, isValid), isValid)
        );
      });
      this.treatments = treatments;

      // Private functions

      function checkValid(id) {
        switch (this.beneficiary) {
          case 3:
            return (
              this.principalMap[id].valid ||
              (this.parent.hasDependentCovered === 1 && this.dependentMap[id].valid)
            );
          case 1:
            return this.principalMap[id].valid;
          case 2:
            return this.dependentMap[id].valid;
          default:
            return false;
        }
      }

      // Public functions

      this.changed = () => {
        this.refreshTreatmentValidity();
      };

      this.refreshTreatmentValidity = () => {
        _.each(this.treatments, (e) => {
          e.treatment.valid = checkValid(e.treatment.id);
        });
      };

      this.toDto = () => {
        if (vm.isHospitalization) {
          return {
            beneficiary: this.beneficiary,
            isPercentage: this.isPercentage,
            value: this.value,
            isAffectingAdmission: this.isAffectingAdmission,
            isAffectingPreHospitalization: this.isAffectingPreHospitalization,
            isAffectingPostHospitalization: this.isAffectingPostHospitalization,
            isAffectingSelfPayHospitalization: this.isAffectingSelfPayHospitalization,
          };
        }
        return {
          beneficiary: this.beneficiary,
          isPercentage: this.isPercentage,
          value: this.value,
          isAffectingNormalDelivery: this.isAffectingNormalDelivery,
          isAffectingCaesareanDelivery: this.isAffectingCaesareanDelivery,
          isAffectingPreNatalCheckUp: this.isAffectingPreNatalCheckUp,
          isAffectingPostNatalFollowUp: this.isAffectingPostNatalFollowUp,
          isAffectingNeoNatal: this.isAffectingNeoNatal,
        };
      };

      // Initialization

      if (dto) {
        automap(dto, this);
        this.refreshTreatmentValidity();
      }
    }

    vm.beneficiary = {
      principal: 1,
      dependent: 2,
    };

    init();
  }
})();
